import { useEffect, useRef } from 'react';

const ShadowDomEmail = ({ html }) => {
    const containerRef = useRef(null);
    const shadowRootRef = useRef(null);

    useEffect(() => {
        if (!containerRef.current || !html) return;

        if (!shadowRootRef.current) {
            shadowRootRef.current = containerRef.current.attachShadow({ mode: 'open' });
        }

        const processedHtml = processEmail(html);
        shadowRootRef.current.innerHTML = processedHtml;

        return () => {
            if (shadowRootRef.current) {
                shadowRootRef.current.innerHTML = '';
            }
        };
    }, [html]);

    return (
        <div
            ref={containerRef}

        />
    );
};

function processEmail(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');


    return doc.body.innerHTML;
}

export default ShadowDomEmail;
